const CountryExposureTable = require('okCharts/CountryExposureTable');

module.exports = CountryExposureTable;
